import React from "react";
import { Grid } from "@material-ui/core";

import { InputMaskCpf, InputMaskCellphone, InputSelect } from "components/form";
import useContact from "./useContact";

import { Subtitle, GroupField, Input, Small } from "../../../Styled";

const Contact = () => {
    const { origemContatoList, getOptionsGender, getOptionsSexualOrientation, getOptionsGenderExtra, dataFields, errors, translate, handleChangeText } = useContact();

    return (
        <React.Fragment>
            <Subtitle>
                {translate("workWithUs.form.step2.title")}<br />
                <Small>{translate("workWithUs.requiredFields")}</Small>
            </Subtitle>

            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            type="tel"
                            id="cpf"
                            name="cpf"
                            label={translate("workWithUs.form.step2.cpf") + ' (*)'}
                            autoComplete="off"
                            value={dataFields?.contact?.cpf || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.cpf}
                            InputProps={{
                                inputComponent: InputMaskCpf,
                            }}
                        />
                    </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            id="name"
                            name="name"
                            label={translate("workWithUs.form.step2.name") + ' (*)'}
                            autoComplete="off"
                            value={dataFields?.contact?.name || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.name}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            id="social_name"
                            name="social_name"
                            label={translate("workWithUs.form.step2.socialName")}
                            autoComplete="off"
                            value={dataFields?.contact?.social_name || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.social_name}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={4} xl={4}>
                    <GroupField>
                        <InputSelect
                            transparent="true"
                            name="gender"
                            id="gender"
                            label={translate("workWithUs.form.step3.gender") + " (*)"}
                            labeldark="false"
                            value={dataFields?.contact?.gender || ""}
                            onChange={(props) =>
                                handleChangeText(props, "contact")
                            }
                            options={getOptionsGender}
                            error={errors?.contact?.gender}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={4} xl={4}>
                    <GroupField>
                        <InputSelect
                            transparent="true"
                            name="genderExtra"
                            id="genderExtra"
                            label={translate("workWithUs.form.step3.genderExtra") + " (*)"}
                            labeldark="false"
                            value={dataFields?.contact?.genderExtra || ""}
                            onChange={(props) =>
                                handleChangeText(props, "contact")
                            }
                            options={getOptionsGenderExtra}
                            error={errors?.contact?.genderExtra}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={4} xl={4}>
                    <GroupField>
                        <InputSelect
                            transparent="true"
                            name="sexualOrientation"
                            id="sexualOrientation"
                            label={translate("workWithUs.form.step3.sexualOrientation") + " (*)"}
                            labeldark="false"
                            value={dataFields?.contact?.sexualOrientation || ""}
                            onChange={(props) =>
                                handleChangeText(props, "contact")
                            }
                            options={getOptionsSexualOrientation}
                            error={errors?.contact?.sexualOrientation}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            type="tel"
                            id="cellphone"
                            name="cellphone"
                            label={`${translate(
                                "workWithUs.form.step2.cellphone"
                            )} (WhatsApp) (*)`}
                            autoComplete="off"
                            value={dataFields?.contact?.cellphone || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.cellphone}
                            InputProps={{
                                inputComponent: InputMaskCellphone,
                            }}
                        />
                    </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            type="tel"
                            id="cellphone2"
                            name="cellphone2"
                            label={`${translate(
                                "workWithUs.form.step2.confirmCellphone"
                            )} (WhatsApp)`}
                            autoComplete="off"
                            value={dataFields?.contact?.cellphone2 || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.cellphone}
                            InputProps={{
                                inputComponent: InputMaskCellphone,
                            }}
                        />
                    </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Input
                            fullWidth
                            transparent="true"
                            type="email"
                            id="email"
                            name="email"
                            label={translate("workWithUs.form.step2.email") + ' (*)'}
                            autoComplete="off"
                            value={dataFields?.contact?.email || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            error={errors?.contact?.email}
                        />
                    </GroupField>
                </Grid>


                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <InputSelect
                            fullWidth
                            transparent="true"
                            id="origin_contact"
                            name="origin_contact"
                            label='Como soube de nós? (*)'
                            labeldark="false"
                            autoComplete="off"
                            value={dataFields?.contact?.origin_contact || ""}
                            onChange={(props) => handleChangeText(props, "contact")}
                            options={origemContatoList}
                            error={errors?.contact?.origin_contact}
                        />
                    </GroupField>
                </Grid>

            </Grid>
        </React.Fragment>
    );
};

export default Contact;
